@if (control(); as control) {
  @if (field(); as field) {
    <div
      class="iot-platform-ui-form-field iot-platform-ui-form-field__{{ field.name?.() }}"
      [ngClass]="{
        'iot-platform-ui-form-field__date-picker': field.type === FormControlType.DATE_PICKER,
        'iot-platform-ui-form-field__date-time-picker': field.type === FormControlType.DATE_TIME_PICKER,
        'iot-platform-ui-form-field__undo-button--bind': field.undo && field.undo?.visible && field.undo?.visible?.()
      }"
      data-cy="iot-platform-ui-form-field"
      fxLayout="row"
      fxLayoutGap="12px"
      fxLayoutAlign="start center"
    >
      @let cmp = getFieldComponent(field.type);
      @if (cmp) {
        <ng-container *ngComponentOutlet="cmp; inputs: { field, control }" />
      }

      @if (field.undo) {
        @if (field.undo?.visible) {
          @if (field.undo?.visible?.()) {
            <ng-container [ngTemplateOutlet]="undoTmpl" />
          }
        } @else {
          <ng-container [ngTemplateOutlet]="undoTmpl" />
        }
      }
    </div>
  }
}

<ng-template #undoTmpl>
  <button
    (click)="onUndoBtnClicked()"
    [class]="'light-button regular-round-button iot-platform-ui-form-field__undo-button iot-platform-ui-form-field__undo-button--' + field()?.name?.()"
    [disabled]="$safeNavigationMigration(field()?.undo?.disabled?.())"
    [matTooltip]="$safeNavigationMigration(field()?.undo?.tooltip?.())! | translate"
    data-cy="iot-platform-ui-form-field-undo-button"
    fxFlex="24px"
    mat-mini-fab
    matTooltipClass="regular-tooltip"
    matTooltipPosition="below"
  >
    @if (!!field()?.undo?.svgIcon?.()) {
      <mat-icon class="iot-platform-ui-form-field__undo-button_icon" [svgIcon]="$safeNavigationMigration(field()?.undo?.svgIcon?.())!" />
    } @else if (!!field()?.undo?.icon?.()) {
      <mat-icon class="iot-platform-ui-form-field__undo-button_icon">{{ field()?.undo?.icon?.() }}</mat-icon>
    }
  </button>
</ng-template>
